// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { getBibliographyTypeById } from 'app/constants/enums/BibliographyType/main';

/* eslint-disable max-len */
export const ARTICLE = getBibliographyTypeById('article');
export const BOOK = getBibliographyTypeById('book');
/* eslint-enable max-len */
